<template>
  <div class="formsAndDocument">
    <!-- <PreloaderPage /> -->
    <BannerPages
      :title="'forms_and_documents.titleForms'"
      :descriptions="[
        $t('forms_and_documents.descriptionForms'),
      ]"
      :img="'/images/forms_and_documents/forms-and-documents-banner.png'"
      mainImageWidthDesk="543"
      mainImageHeightDesk="475"
      alt="Phone and laptop with document"
    />
    <TabFiles  :style="degrade"/>

    <div class="ensure_protected">
      <LazyMoreResource
        :titleH2="'forms_and_documents.protectedTitle'"
        :cards="cards"
        class="with-icons"
      />
    </div>

    <div class="help">
      <LazyConnect :title="'forms_and_documents.titleHelp'" />
    </div>

    <client-only>
      <LazyInvestment
        :label="'forms_and_documents.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import TabFiles from "~/components/forms_and_documents/TabFiles";
import LazyTabFileslatam from "~/components/forms_and_documents/TabFileslatam";
import LazyMoreResource from "~/components/home/MoreResource";
import LazyConnect from "~/components/contacts/Connect.vue";
// import PreloaderPage from "~/components/PreloaderPage.vue";
import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports';

const { getExternalUrl } = useExternalUrl();
const { t, locale } = useI18n();
const { $regulationsVar } = useNuxtApp();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const nuxtImg = useImage();

const title = t("seo.form-and-documents.title");
const description = t("seo.form-and-documents.description");
const imgSeo = 'https://tradeview.eu/images/seo/06Formsanddocuments.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/forms_and_documents/Formsanddocuments-Gradient1.avif';
const optimizedDegrade = nuxtImg(degradadeImageUrl, {
    quality: 50,
    format: 'avif',
});

const degrade = computed(() => {
    return {
        '--degrade': `url('${optimizedDegrade}')`,
    };
});

let cards = ref([
  {
    icon: "autorenew",
    title: "forms_and_documents.protectedCardTitle1",
    desc: "forms_and_documents.protectedCardDesc1",
  },
  {
    icon: "account_balance_wallet",
    title: "forms_and_documents.protectedCardTitle2",
    desc: "forms_and_documents.protectedCardDesc2",
  },
  {
    icon: "lock",
    title: "forms_and_documents.protectedCardTitle3",
    desc: "forms_and_documents.protectedCardDesc3",
  },
  {
    icon: "acute",
    title: "forms_and_documents.protectedCardTitle4",
    desc: "forms_and_documents.protectedCardDesc4",
  },
]);
</script>
